// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"IconWithUnderline_iconContainer__R0p9n","underline":"IconWithUnderline_underline__vJu2d","icon":"IconWithUnderline_icon__FDQhc"};